import { createSlice } from '@reduxjs/toolkit';
import { getAccessToken, getRefreshToken, getUserName } from '../utils/auth';

const appSlice = createSlice({
  // 切片的名字用来区分不同的数据源是唯一标示
  name: 'app',
  // 状态默认值
  initialState: {
    user: getUserName(),
    accessToken: getAccessToken(),
    refreshToken: getRefreshToken(),
    // 顶部导航栏
    tabBarAcyive: 'industryChart',
    // 数据缓冲
    dataBuffer: {},
    // 日报首页搜索关键字
    keyword: '',
    // 首页日报展示筛选框类型city/industry
    modalType: '',
    init: 'hello',
    // // 搜索详情页有数据的项
    searchData: [],
  },
  // 更新状态
  reducers: {
    setUser: (state, { payload }) => {
      state.user = payload;
    },
    setAccessToken: (state, { payload }) => {
      state.accessToken = payload;
    },
    setRefreshToken: (state, { payload }) => {
      state.refreshToken = payload;
    },
    setTabBarActive: (state, { payload }) => {
      state.tabBarAcyive = payload;
    },
    setDataBuffer: (state, { payload }) => {
      state.dataBuffer = { ...state.dataBuffer, ...payload };
    },
    setModalType: (state, { payload }) => {
      state.modalType = payload;
    },
    setKeyword: (state, { payload }) => {
      state.keyword = payload;
    },
    setSearchData: (state, { payload }) => {
      state.searchData = payload;
    },
  },
});

// 导出更新状态的方法
export const {
  setUser,
  setAccessToken,
  setRefreshToken,
  setTabBarActive,
  setDataBuffer,
  setModalType,
  setKeyword,
  setSearchData,
} = appSlice.actions;

// 导出切片
export default appSlice.reducer;
